module.exports = __webpack_public_path__ + "static/media/blackdownarrow.55f9fb36.svg";